module.exports = __webpack_public_path__ + "static/media/How can you customized document type in the system.4b55b069.png";